import {
  Body2,
  Button,
  Card,
  CardFooter,
  CardHeader,
  Title2,
} from "@fluentui/react-components";

export const PermissionUpgradeNotAvailable = ({
  onReturnToLobby,
}: {
  onReturnToLobby: () => void;
}) => (
  <Card size="large" className="w-full max-w-lg">
    <CardHeader header={<Title2>Permission upgrade unavailable</Title2>} />
    <Body2>
      Enterprise clients handle permission in their Microsoft Teams Admin
      dashboard. Please reach out to BeZoned team for the current list of
      permissions required to run BeZoned app.
    </Body2>
    <CardFooter className="flex justify-end gap-2">
      <Button appearance="primary" onClick={onReturnToLobby} type="button">
        Return to Lobby
      </Button>
    </CardFooter>
  </Card>
);
